module.exports = __webpack_public_path__ + "static/media/img2-1.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/biosense/diff/img2-1.png
// module id = 1270
// module chunks = 3